import "./App.scss"

import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import BookList from "./Component/BookList"
import CompanyList from "./Component/CompanyList"
import ZoneQR from "./Component/ZoneQR"
import CSVBookDetail from "./Component/CSVBookDetail"
import AdminPanel from "./Component/AdminPanel"
import { ProjectProvider } from "./contexts/ProjectContext"
import { RedirectProvider } from "./contexts/RedirectContext"
import { DataCacheProvider } from "./contexts/DataCacheContext"

function App() {
  return (
    <Router>
      <DataCacheProvider>
        <ProjectProvider>
          <RedirectProvider>
            <Routes>
              {/* Static routes first (higher priority) */}
              <Route exact path="/" element={<BookList />} />
              <Route path="/books" element={<BookList />} />
              <Route path="/books/booklist" element={<BookList />} />
              <Route path="/companies" element={<CompanyList />} />
              <Route path="/zones" element={<ZoneQR />} />
              <Route path="/admin" element={<AdminPanel />} />
              <Route path="/book/:bookid" element={<CSVBookDetail />} />
              <Route path="/company/:companyid" element={<CSVBookDetail />} />

              {/* Dynamic project routes (any valid project ID) */}
              <Route path="/:projectId/book/:bookid" element={<CSVBookDetail />} />
              <Route path="/:projectId/company/:companyid" element={<CSVBookDetail />} />
              <Route path="/:projectId/books" element={<BookList />} />
              <Route path="/:projectId/books/booklist" element={<BookList />} />
              <Route path="/:projectId/companies" element={<CompanyList />} />
              <Route path="/:projectId/zones" element={<ZoneQR />} />
            </Routes>
          </RedirectProvider>
        </ProjectProvider>
      </DataCacheProvider>
    </Router>
  )
}

export default App